exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wib-feature__content__text {\n  color: #5F707F;\n  font-size: 16px;\n  line-height: 21px;\n}\n.wib-feature__content__text p {\n  margin: 0;\n}", ""]);

// exports
